<script lang="ts">
    export let err: Error;
</script>

<div class="alert alert-danger animate__animated animate__jello" role="alert">
    {err}
</div>